export enum EArtType {
  text = 0, // электронный текст
  audio = 1, // аудиокнига
  pdf = 4, // PDF-книга
  gift = 10, // подарочные карты
  gardner = 11, // Gardner books
  read = 12, // книги read.ru
  ozonText = 16, // книги ozon.ru
  ozonAudio = 17, // аудиокниги ozon.ru
  olesiejukAudio = 18, // аудиокниги Olesiejuk
  olesiejukText = 19, // книги Olesiejuk
  podcast = 22, // подкаст
  podcastEpisode = 23, // выпуск подкаста
  epub = 24, // epub книга
  webtoon = 25, // Вебтун
  webtoonChapter = 26, // Глава вебтуна
}
